import React, { MouseEvent } from 'react';

import { SurveyValueExcelFailure } from '../../../../../types/entity.types';

import Button from '../../../../common/button/Button';
import Modal from '../../../../common/modal/Modal';

import '../accountability.scss';
import './survey-upload-failure-modal.scss';

type FailuresProps = {
  failures?: SurveyValueExcelFailure[];
};

const Failures = ({ failures }: FailuresProps) => {
  return (
    <div className="survey-upload-failure-modal__failures visible-scrollbar">
      {failures?.map((result) => (
        <p className="survey-upload-failure-modal__failure" key={result.surveyAnswerExcel.rowNumber}>
          {result.failureReasons.join(', ')}
        </p>
      ))}
    </div>
  );
};

type Props = {
  show: boolean;
  close: (event: MouseEvent<HTMLButtonElement>) => void;
  failures?: SurveyValueExcelFailure[];
};

const SurveyUploadFailureModal = ({ show, close, failures }: Props) => {
  if (!show) return <></>;

  return (
    <Modal show={show}>
      <section className="survey-upload-failure-modal">
        <h1 className="survey-upload-failure-modal__header">Upload Failure</h1>
        <p className="survey-upload-failure-modal__message">
          We found the following issue(s) while processing the file:
        </p>

        <Failures failures={failures} />

        <p className="survey-upload-failure-modal__message">Please review and update your list.</p>
        <div className="survey-upload-failure-modal__button-container">
          <Button text="Okay" onClick={close} />
        </div>
      </section>
    </Modal>
  );
};

export default SurveyUploadFailureModal;
